import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { IStandard } from "src/domain/entities"
import { standardDeleteService } from "src/domain/services/standard/standardDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"

interface Props {
	standard: IStandard
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const StandardDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	standard,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleStandardDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await standardDeleteService({ id: standard.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [standard, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Standard: ${standard.name}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleStandardDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
